<template>
  <div class="contai_h">
    <!-- 这是头部信息 -->
    <div class="contai">
      <i class="el-icon-s-home">
        <router-link to="/">首页</router-link>
        <span class="head_text">>逾期订单 </span>
      </i>
      <div class="haed_cont">
        <span>今天是：{{ deta }}</span>
      </div>

      <div class="head_right">
        <span>逾期订单：{{ len }}</span>
      </div>
    </div>
    <!-- 这是数据看板栏 -->
    <div class="contai_sj">
      <div class="cont_co">
        <div class="conta_box">
          <span class="con_text">今日逾期：{{ dayorder }}</span>
        </div>
        <div class="conta_box">
          <span class="con_text">当前逾期：{{ len }}</span>
        </div>
        <div class="conta_box">
          <span class="con_text">逾期总金额：{{ price }}元</span>
        </div>
      </div>
    </div>

    <!-- 数据详细列表 -->
    <div class="contai_li">
      <el-table :data="this.items" style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="当户姓名：">
                <span>{{ props.row.name }}</span>
              </el-form-item>
              <el-form-item label="联系电话"
                >:
                <span>{{ props.row.telephone }}</span>
              </el-form-item>
              <el-form-item label="典当物品"
                >:
                <span>{{ props.row.itemlb }}</span>
              </el-form-item>
              <el-form-item :label="props.row.nf"
                >:
                <span>{{ props.row.attrsx }}</span>
              </el-form-item>
              <el-form-item :label="props.row.zl"
                >:
                <span>{{ props.row.typezl }}</span>
              </el-form-item>
              <el-form-item :label="props.row.weight"
                >:
                <span>{{ props.row.itemattsx }}</span>
              </el-form-item>
              <el-form-item label="典当周期"
                >:
                <span>{{ props.row.mode }}天</span>
              </el-form-item>
              <el-form-item label="典当价格"
                >:
                <span>{{ props.row.price }}元</span>
              </el-form-item>
              <el-form-item label="开始日期"
                >:
                <span>{{ props.row.date }}</span>
              </el-form-item>
              <el-form-item label="结束日期"
                >:
                <span>{{ props.row.preFinishedDate }}</span>
              </el-form-item>
              <el-form-item label="鉴定方式"
                >:
                <span>{{ props.row.mod }}</span>
              </el-form-item>
              <el-form-item label="当品描述"
                >:
                <span>{{ props.row.descrms }}</span>
              </el-form-item>
              <el-form-item label="典当状态"
                >:
                <span>{{ props.row.state }}</span>
              </el-form-item>
              <el-form-item label="收货地址"
                >:
                <span>{{ props.row.sfdz }}</span>
              </el-form-item>
              <el-form-item label="收款开户行"
                >:
                <span>{{ props.row.userinfo }}</span>
              </el-form-item>
              <el-form-item label="收款银行账号"
                >:
                <span>{{ props.row.userbank }}</span>
              </el-form-item>
              <el-form-item label="证件号码"
                >:
                <span>{{ props.row.idcard }}</span>
              </el-form-item>
            </el-form>
            <div class="con">
              <span>逾期续赎当：</span>
              <el-button type="primary" @click="cliSho(props.row._id)"
                >操作</el-button
              >
              <div class="con_head" v-show="clik">
                <el-switch
                  v-model="props.row.ces"
                  active-text="不可逾期续赎"
                  inactive-text="可逾期续赎"
                  @change="handleUpdate"
                >
                </el-switch>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="当户" prop="name"> </el-table-column>
        <el-table-column
          prop="date"
          label="开始日期"
          sortable
          column-key="date"
          :filter-method="filterHandler"
        >
        </el-table-column>
        <el-table-column label="结束日期" prop="preFinishedDate">
        </el-table-column>
        <el-table-column label="典当物品" prop="itemlb"> </el-table-column>
        <el-table-column label="典当状态" prop="state"> </el-table-column>
        <el-table-column label="典当金额" prop="price"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "Beo",
  data() {
    return {
      ACCESS_TOKEN: "", //拿到ACCESS_TOKEN
      deta: "", //请求今天的日期
      len: "", //逾期订单总数量
      price: "", //逾期订单的总金额
      dayorder: "", //今天逾期的订单
      items: [], //获取到的数据列表
      id: "", //拿到当前点击的id
      clik: false,
    };
  },

  methods: {
    resetDateFilter() {
      this.$refs.filterTable.clearFilter("date");
    },
    filterTag(value, row) {
      return row.tag === value;
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },

    cliSho(e) {
      this.id = e;
      this.clik = !this.clik;
    },
    //  同意当户逾期续赎当
    update() {
      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("user_ddxx").doc("' +
            this.id +
            '").update({data:{ces:true}})',
        })
        .then(() => {
          this.$message({
            showClose: true,
            message: "已关闭，当户不可以进行逾期续赎当哦！！",
            type: "success",
            center: true,
          });
        })
        .catch(() => {
          this.$message.error("请刷新页面后重试...");
        });
    },
    //不同意当户逾期续赎当
    noupdate() {
      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("user_ddxx").doc("' +
            this.id +
            '").update({data:{ces:false}})',
        })
        .then(() => {
          this.$message({
            showClose: true,
            message: "已打开，当户将可以进行逾期续赎当哦！！",
            type: "warning",
            center: true,
          });
        })
        .catch(() => {
          this.$message.error("请刷新页面后重试...");
        });
    },
    handleUpdate(e) {
      if (e) {
        this.update();
      } else {
        this.noupdate();
      }
    },

      
  },
  created(){
//请求token
this.getTokens()

//请求当前登录的用户信息
this.getUserToken()
  },

  mounted() {
    this.deta = dayjs().format("YYYY-MM-DD ddd");

     setTimeout(()=>{
       this.axios
      .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
        env: `${this.userData.env}`,
        query:
          'db.collection("user_ddxx").where({state:"逾期"}).get()',
      })
      .then((aa) => {
        if(aa.data.errcode !==0){
          return  this.$notify.error({
              title: '错误提示',
              message: '密钥过期啦，请刷新页面'
            });
        }
        aa.data.data.forEach((element, index, array) => {
          array[index] = JSON.parse(element);
        });
        this.items = aa.data.data;
        this.len = aa.data.data.length;

        //循环计算逾期的总金额
        let str = "";
        for (let i in this.items) {
          str += this.items[i].price;
          str += "+";
        }
        str = str.substring(0, str.length - 1);
        this.price = eval(str);

        //过滤筛选今天逾期的订单
        let products = this.items.filter(function (product) {
          return (
            product.preFinishedDate ===
            dayjs().subtract(1, "day").format("YYYY-MM-DD")
          );
        });
        this.dayorder = products.length;
      });
     },800)
    
   
  
  },
};
</script>
<style scoped>
.contai_h {
  margin: 0 0;
}
.contai {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
}
.contai i {
  font-size: 25px;
  margin: 13px 40px;
}
.head_text {
  font-size: 20px;
  margin: 2px 6px;
}
.router-link-active {
  text-decoration: none;
  font-size: 20px;
  margin-left: 10px;
}
.haed_cont {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
  font-size: 20px;
}
.head_right {
  margin: 13px 50px;
  font-size: 20px;
}
.contai_sj {
  width: 100%;
  height: 150px;
  background-color: #ffffff;
  margin-top: 10px;
  border-radius: 10px;
}
.cont_co {
  display: flex;
  flex-direction: row;
}
.conta_box {
  width: 350px;
  height: 120px;
  background-color: #a9d463;
  border-radius: 15px;
  margin: 16px auto;
}
.con_text {
  color: #ffffff;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 37px 0;
}
.contai_li {
  width: 100%;
  height: 100px;
  background-color: #ffffff;
  margin-top: 10px;
}
/* 列表的样式 */
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 25%;
}
.con {
  margin: 20px 0;
}
.con_head {
  margin: 20px 0;
}
</style>